import { render } from "./industry.vue?vue&type=template&id=634178ac"
import script from "./industry.vue?vue&type=script&lang=js"
export * from "./industry.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/brandProduct/components/industry.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "634178ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('634178ac', __exports__)) {
    console.log('reload')
    api.reload('634178ac', __exports__)
  }
  
  module.hot.accept("./industry.vue?vue&type=template&id=634178ac", () => {
    console.log('re-render')
    api.rerender('634178ac', render)
  })

}


export default __exports__